import { getOptionValue } from './factories';

export const getOptionAmountReferenceCurrency = getOptionValue('amountReferenceCurrency');
export const getOptionAmountReferenceIsOverridden = getOptionValue('amountReferenceIsOverridden');
